import { type ReactNode } from 'react';

import { TooltipProvider } from '@/components/ui/tooltip';

import { QueryProvider } from './query-provider';
import { ToastProvider } from './toast-provider';

/**
 * Aglomerado de providers app-wide. Adicione providers novos AQUI —
 * `main.tsx` só renderiza `<AppProviders>` + `<RouterProvider>`.
 *
 * Ordem importa: providers de baixo (children-first) só veem providers
 * acima.
 */
export function AppProviders({ children }: { readonly children: ReactNode }) {
  return (
    <QueryProvider>
      <TooltipProvider delayDuration={200}>
        {children}
        <ToastProvider />
      </TooltipProvider>
    </QueryProvider>
  );
}
